export const formatDate = (dateString: string | Date | null | undefined) => {
  if (dateString === null || dateString === undefined || dateString === "") {
    return "";
  }

  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return "";
    }
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}/${month}/${day}`;
  } catch {
    return "";
  }
};
